<template>
  <div>
    <template v-if="!loading">
      <h1>{{ $lang("TITLE_FAMILY_GAME") }}</h1>
      <div class="dashed summer-carnival">
        <div class="reshtml" v-if="familyGuideLines.content" v-html="familyGuideLines.content"></div>
        <div v-if="!isFull" class="options">
          <span class="listen-tnc">
            <a :href="pdf" :download="$lang('TITLE_FAMILY_GAME')" target="_blank">{{ $lang("TEXT_SEE_ALL_PAGE") }}</a>
          </span>
          <span class="listen-tnc" v-if="!familyReadonly && !is_show" @click="sumbit">{{
            $lang("TEXT_AGREE_CONTENT")
          }}</span>
          <p v-if="familyReadonly && !is_show">{{ $lang("TIP4") }}</p>
        </div>
        <template v-if="is_show">
          <list :list="members"></list>
          <div v-if="records.length > 0">
            <p style="font-size: 16px; font-weight: 700">
              {{ $lang("已提交") }}:
            </p>
            <ul>
              <template v-for="item in records">
                <li v-if="item.is_submit" :key="item.id">
                  <span></span>
                  <router-link class="submitForm" :to="`single-family-game/perview/${item.id}`">{{ item.label
                  }}</router-link>
                  <span
                    v-if="hasParticipantStatus(item)"
                    class="participant-status"
                  >
                    {{ participantStatusText(item) }}
                  </span>
                  <p
                    v-if="item.participantRemark"
                    class="participant-remark"
                  >
                    {{ $t("備註") }}：{{ item.participantRemark }}
                  </p>
                </li>
                <li v-if="!familyReadonly && !item.is_submit" :key="item.id">
                  <span>{{ item.label }}</span>
                  <span
                    v-if="hasParticipantStatus(item)"
                    class="participant-status"
                  >
                    {{ participantStatusText(item) }}
                  </span>
                  <p
                    v-if="item.participantRemark"
                    class="participant-remark"
                  >
                    {{ $t("備註") }}：{{ item.participantRemark }}
                  </p>
                  <router-link class="btn btn-primary" :disabled="btnLoading"
                    :to="`single-family-game/edit/${item.id}`">{{ $lang("修改") }}</router-link>
                  <b-btn variant="danger" :disabled="btnLoading" @click="handlerSumbit(item.id)">
                    <b-spinner v-if="btnLoading" style="margin-right: 10px" small label="Small Spinner"></b-spinner>
                    {{ $lang("提交") }}</b-btn>
                  <b-btn variant="info" :disabled="btnLoading" @click="handlerCancle(item.id)">{{ $lang("刪除") }}</b-btn>
                  <!-- 未完成線上報名 -->
                  <span style="color:red;">*{{ $lang("uncompleted_registration") }}</span>
                </li>
              </template>
            </ul>
          </div>
          <p v-if="familyReadonly">{{ $lang("TIP4") }}</p>
          <div>
            <b-btn :disabled="familyReadonly" variant="info btn-round" @click="sumbit">+{{ $lang("TITLE_ADD_GAME_TEXT")
            }}</b-btn>

            <router-link to="account" class="btn btn-info btn-round">&nbsp;&nbsp;{{
              $lang("TITLE_RETURN_INDEX")
              }}&nbsp;&nbsp;</router-link>
            <router-link v-if="isShowMember > 3" to="family-game-form" class="btn btn-success btn-round">{{
              $lang("查看家庭成員")
            }}</router-link>
          </div>
        </template>
      </div>
      <p v-if="isFull">
        <span>
          <h4>{{ $lang("報名名額已滿") }}</h4>
        </span>
      </p>
    </template>
    <template v-else>
      <div class="spinner">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </template>
  </div>
</template>
<script>
import { $apis } from "@/helper";
import game from "@/components/game";
import List from "@/components/List";
export default {
  components: {
    game,
    List,
  },
  data() {
    return {
      btnLoading: false,
      loading: true,
      isReadOnly: true,
      records: [],
      members: [],
      regComp: false,
      isShowMember: false,
    };
  },
  created() {
    this.$store.dispatch("base/getPage");
    this.isLoading();
    // console.log(this.popupMsg);
  },
  mounted() {
    console.log("mounted", this.$store.state);
  },
  computed: {
    popupMsg() {
      return this.$store.state.base.popupMsg;
    },
    familyGuideLines() {
      return this.$store.state.base.familyGuideLines;
    },
    familyReadonly() {
      return this.$store.state.base.familyReadonly;
    },
    isFull() {
      return this.$store.state.base.familyDayisFull;
    },

    is_show() {
      return this.members.length > 0;
    },
    btn_add() {
      return this.members.some((item) => {
        return !item.isAdult && !item.is_used;
      });
    },
    locale() {
      return this.$route.params.locale;
    },
    pdf() {
      if (this.$getLocale() == "zh-hant") {
        if (this.$store.getters["base/FamilyDay2019"]) {
          return this.$store.getters["base/FamilyDay2019"].replace(
            /%local%/,
            "-C"
          );
        }
      } else {
        if (this.$store.getters["base/FamilyDay2019"]) {
          return this.$store.getters["base/FamilyDay2019"].replace(
            /%local%/,
            "-P"
          );
        }
      }
    },
  },
  watch: {
    popupMsg(n) {
      // console.log(n,"监听");
      if (n) {
        this.popup();
      }
    },
  },
  methods: {
    popup() {
      var that = this;
      var timer = null;
      console.log(this.popupMsg, "pop");
      if (this.popupMsg) {
        newSwal();
      }
      function newSwal() {
        let html = "";
        for (let index = 0; index < that.popupMsg.child.length; index++) {
          html += `<div id='${that.popupMsg.child[index].slug}' style="display: none">${that.popupMsg.child[index].description}	</div>`;
        }

        // <div id="home-tab2" style="display: none">
        // 	  <p> ${that.popupMsg.child[0].description}</p>
        // 	</div>
        Swal.fire({
          title: that.popupMsg.title,
          html:
            `<div>
							<h1></h1>
							<div>
                ${that.popupMsg.description}
							</div>` +
            html +
            `</div>`,
          confirmButtonText: `<span id="count"><span> ${that.$lang(
            "我知道了"
          )}`,
          allowOutsideClick: false,
          showConfirmButton: true,
        });
        Swal.getConfirmButton().style.display = "none";
      }

      function countDown(s = 5) {
        clearInterval(timer);
        Swal.disableButtons();
        document.getElementById("count").innerHTML = `${that.$lang(
          "我知道了"
        )}（${s}）`;
        timer = setInterval(() => {
          s -= 1;
          document.getElementById("count").innerHTML = `${that.$lang(
            "我知道了"
          )}（${s}）`;
          if (s === 0) {
            clearInterval(timer);
            Swal.enableButtons();
            document.getElementById("count").innerHTML = `${that.$lang(
              "我知道了"
            )}`;
          }
        }, 1000);
      }

      process(({ node, attrName, attrValue }) => {
        node.addEventListener("click", () => {
          process(({ node, attrName, attrValue }) => {
            document.getElementById(attrValue).style.display = "none";
          });
          let display = document.getElementById(attrValue).style.display;
          if (display == "none") {
            countDown();
            document.getElementById(attrValue).style.display = "block";
            Swal.getConfirmButton().style.display = "block";
          }
          if (display == "block") {
            document.getElementById(attrValue).style.display = "none";
          }
        });
      });

      function process(cb) {
        let links = document.querySelectorAll(".link");
        links.forEach((node) => {
          Array.from(node.attributes).forEach((attr) => {
            const attrName = attr.name;
            const attrValue = attr.value;
            if (attrName === "data-target") {
              cb({
                node,
                attrName,
                attrValue,
              });
            }
          });
        });
      }
    },
    isLoading() {
      this.loading = true;
      Promise.all([this.getFamilyList(), this.getFamilyRecord()])
        .then((resp) => { })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeName(item) {
      return (
        (item.firstName || item.lastNameOther) +
        (item.lastName || item.firstNameOther)
      );
    },
    hasParticipantStatus(item) {
      return typeof item.isParticipant === "boolean";
    },
    participantStatusText(item) {
      return item.isParticipant ? this.$lang("參賽") : this.$lang("不參賽");
    },
    // 获取家庭成员列表
    getFamilyList() {
      return $apis.family
        .familyList()
        .then((resp) => {
          this.members = resp.data.members;
          this.isReadOnly = resp.data.isReadOnly;
          let countRecords = resp.data.countRecords;
          let length = resp.data.members.filter((item) => !item.isAdult).length;
          this.isShowMember = resp.data.members.length;
          this.regComp = countRecords === 0 || !(length == countRecords);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取报名列表
    getFamilyRecord() {
      return $apis.family
        .familyRecord()
        .then((resp) => {
          this.records = resp.data.records;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 提交报名
    submitFamilyRecord(id) {
      $apis.family
        .submitFamilyRecord({
          id,
        })
        .then((resp) => {
          this.notification.success(this.$lang("TEXT_SUBMBIT_SUCCESS"));
          this.getFamilyRecord();
          this.btnLoading = false;
        })
        .catch((err) => {
          this.notification.error(err.message);
          console.log(err);
          this.btnLoading = false;
        });
    },
    // 刪除報名表
    cancelFamilyRecord(id) {
      $apis.family
        .cancelFamilyRecord({
          id,
        })
        .then((resp) => {
          this.getFamilyRecord();
          this.getFamilyList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handlerCancle(id) {
      var r = confirm(this.$lang("是否刪除報名表!"));
      if (r == true) {
        this.cancelFamilyRecord(id);
      }
    },
    handlerSumbit(id) {
      var r = confirm(this.$lang("是否確認提交!"));
      if (r == true) {
        this.btnLoading = true;
        this.submitFamilyRecord(id);
      }
    },
    sumbit() {
      console.log(11);
      this.$router.push({
        name: "family-game",
      });
    },
  },
};
</script>
